export default __webpack_public_path__ + "static/media/drstile-website-2.7edbb22d.jpg";